import React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'Utils/selectors';
import AppSumoActiveScreen from '../AppSumoActiveScreen';
import BillingDefaultPlanScreen from '../BillingDefaultPlanScreen';
import { User } from 'Interfaces/User';
import { BillingPageAction } from '../BillingDefaultPlanScreen/planTableItems';
import { useLocation } from 'react-router-dom';

interface PageParameters {
  action?: BillingPageAction;
}

const BillingPlan = () => {
  const location = useLocation<PageParameters>();
  const { appSumoStatus }: User = useSelector(selectUser);

  if (appSumoStatus) {
    return <AppSumoActiveScreen />;
  }

  return <BillingDefaultPlanScreen pageAction={location.state?.action} />;
};

export default BillingPlan;
